<template>
  <div class="card-message">
    <div
      class="card"
      v-for="(item, index) in items"
      :key="index"
    >
      <h4>{{ item.title }}</h4>
      <p>{{ item.description }}</p>
      <div class="buttons">
        <button
          v-for="(action, i) in item.actions"
          :key="i"
          @click="handleAction(action)"
        >
          {{ action.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardMessage',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleAction(action) {
      if (action.type === 'link' && action.uri) {
        window.open(action.uri, '_blank');
      } else if (action.type === 'replay') {
        this.$emit('send', action.text);
      }
    },
  },
};
</script>

<style scoped>
:deep(.bubble.is-text) {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.card-message {
  background-color: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
}

.card {
  background-color: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: none !important;
}

.buttons {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.buttons button {
  margin: 0;
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  width: 100%;
}

.buttons button:hover {
  background-color: #1e40af;
}
</style>